export default __webpack_public_path__ + "static/media/UBER_NEW.dc756568.png";